import DjangoFormWrapper from 'layout_congress/vue/formsV2/DjangoFormWrapper.vue'
import { RouteRecordRaw } from "vue-router"

import { $gettext } from 'gettext-congress'


export const routes: RouteRecordRaw[] = [
    {
        path: "profile/",
        children: [
            {
                name: "participant-user-profile-create",
                path: "create/",
                component: DjangoFormWrapper,
                meta: {
                    form: true,
                },
            },
            {
                name: "participant-user-profile-required",
                path: "required/",
                component: DjangoFormWrapper,
                meta: {
                    form: true,
                },
            },
            {
                name: "participant-user-profile-edit",
                path: "edit/",
                component: DjangoFormWrapper,
                meta: {
                    form: true,
                },
            },
        ]
    },
    {
        path: "public/",
        children: [
            {
                name: "user-collection-info",
                path: "",
                component: () => import("#src/vue/page/user/public/info/PublicInfoPage.vue"),
            },
        ],
        meta: {
            breadcrumbs: [
                "pageData:collection.name",
            ],
        },
    },
    {
        path: "proposal/",
        meta: {
            breadcrumbs: [
                ["pageData:collection.name", {name: 'user-collection-info'}],
            ],
        },
        children: [
            {
                name: "participant-proposal-create",
                path: "create/",
                components: {
                    "default": DjangoFormWrapper,
                },
                meta: {
                    form: true,
                    breadcrumbs: [
                        $gettext("Create motion"),
                    ],
                },
            },
            {
                name: "participant-proposal-update",
                path: ":proposal_uid/edit/",
                components: {
                    "default": DjangoFormWrapper,
                },
                meta: {
                    form: true,
                },
            },
            {
                name: "participant-proposal-delete",
                path: ":proposal_uid/delete/",
                components: {
                    "default": DjangoFormWrapper,
                },
                meta: {
                    form: true,
                    contentWrapperClasses: 'col-12 col-md-8 col-lg-6',
                },
            },
            {
                name: "participant-proposal-submit",
                path: ":proposal_uid/submit/",
                components: {
                    "default": DjangoFormWrapper,
                },
                meta: {
                    form: true,
                    contentWrapperClasses: 'col-12 col-md-8 col-lg-6',
                },
            },
        ],
    },
    // {
    //     name: "participant-proposal-list",
    //     path: "proposals",
    //     component: import("./UserProposalsPage.vue"),
    // }
]

export default routes
